import React, { useState } from 'react';
import { useField } from 'formik';
import { Input } from 'reactstrap';
import FieldWrapper from './FieldWrapper';
import classNames from 'classnames';

const FormikPassword = (props) => {
  const {
    name,
    label,
    fieldClassName,
    className,
    defaultType = 'password',
    icon,
    isDefaultIcon,
    ...restProps
  } = props;
  const [field, meta] = useField(name);

  const [passwordType, setPasswordType] = useState(defaultType);
  const togglePasswordType = () => {
    setPasswordType((val) => (val === 'password' ? 'text' : 'password'));
  };

  return (
    <FieldWrapper
      name={name}
      label={label}
      fieldClassName={classNames("form-field-password", fieldClassName)}
      className={className}
    >
      {(!!isDefaultIcon || !!icon) && (
        <div className="form-floating-icon">
          {isDefaultIcon ? <i className="fa fa-lock" /> : icon}
        </div>
      )}
      <Input
        name={name}
        type={passwordType}
        invalid={meta?.touched && !!meta?.error}
        {...restProps}
        {...field}
      />

      <button
        type="button"
        className="btn btn-link btn-password-addon position-absolute text-muted h-100 end-0 top-0"
        onClick={togglePasswordType}
      >
        <i
          className={`far ${
            passwordType === 'password' ? 'fa-eye' : 'fa-eye-slash'
          }`}
        />
      </button>
    </FieldWrapper>
  );
};

export default FormikPassword;
